import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'
import { useToast } from '@/hooks/use-toast'
import { useI18n } from '@/store/I18nContext'

interface DemoDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function DemoDialog({ open, onOpenChange }: DemoDialogProps) {
  const { toast } = useToast()
  const { t } = useI18n()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    toast({
      title: t('demo.successTitle'),
      description: t('demo.successDesc'),
    })
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t('demo.title')}</DialogTitle>
          <DialogDescription>{t('demo.desc')}</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label htmlFor="name">{t('demo.name')}</Label>
            <Input id="name" required placeholder="João da Silva" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="company">{t('demo.company')}</Label>
            <Input id="company" required placeholder="Estacionamento Central" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">{t('demo.email')}</Label>
            <Input
              id="email"
              type="email"
              required
              placeholder="joao@empresa.com.br"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="phone">{t('demo.phone')}</Label>
            <Input
              id="phone"
              type="tel"
              required
              placeholder="(11) 99999-9999"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="spots">{t('demo.spots')}</Label>
            <Input
              id="spots"
              type="number"
              required
              placeholder="Ex: 50"
              min="1"
            />
          </div>
          <Button type="submit" className="w-full mt-2 font-bold h-12">
            {t('demo.submit')}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  )
}
